import * as React from 'react'
import { TeamCardConnected } from './TeamCardConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore, MOCK_TEAM_A_ID } from 'mockState'

export const TeamCardExamples = () => {
  return (
    <div className="TeamCardExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TeamCardConnected teamId={MOCK_TEAM_A_ID} />
      </Provider>
    </div>
  )
}
